<main id="main-content" tabindex="-1">
  <form [formGroup]="attachmentForm"
    class="flex flex-col gap-4 py-3"
    (ngSubmit)="submitResource()">
    <div class="col-span-2">
      <prism-input
        label="Add Atachment"
        [control]="attachmentForm.get('fileName')"
        placeHolder="Choose a file to upload"
        [inputType]="InputType.File"
        identifier="attachment"
        (fileChange)="fileChange($event)"
        acceptFileType="image/*, .pdf, .xls, .xlsx, .csv"
        [disabled]="filePickerDisabled || isUploading">
      </prism-input>
    </div>
    <prism-btn btnClass="btn-purple" [disabled]="isUploading || !selectedFile">
      {{ isUploading ? 'Uploading…' : 'Save and Add Attachment' }}
    </prism-btn>
  </form>
</main>
